const PREFIX = 'CUSTOMER_LIST_'

export const CUSTOMER_LIST_PAGE_REQUEST = `${PREFIX}PAGE_REQUEST`

/******************************************************************************************
 * Customer List
 ******************************************************************************************/

export const CUSTOMER_LIST_CUSTOMERS_REQUEST = `${PREFIX}CUSTOMERS_REQUEST`

export const CUSTOMER_LIST_SET_CUSTOMERS = `${PREFIX}SET_CUSTOMERS`

export const CUSTOMER_LIST_SET_TOTAL_PAGE = `${PREFIX}SET_TOTAL_PAGE`

export const CUSTOMER_LIST_SET_CURRENT_PAGE = `${PREFIX}SET_CURRENT_PAGE`

export const CUSTOMER_LIST_SET_KEYWORD = `${PREFIX}SET_KEYWORD`

export const CUSTOMER_LIST_SET_TYPE = `${PREFIX}SET_TYPE`

export const CUSTOMER_LIST_SET_SUMMARY = `${PREFIX}SET_SUMMARY`

export const CUSTOMER_LIST_SET_HAS_LOYALTY = `${PREFIX}SET_HAS_LOYALTY`

/******************************************************************************************
 * End Customer List
 ******************************************************************************************/

 /******************************************************************************************
  * Customer redemption histories
  ******************************************************************************************/
export const CUSTOMER_LIST_SET_REDEMPTION_HISTORIES = `${PREFIX}SET_REDEMPTION_HISTORIES`

export const CUSTOMER_LIST_REDEMPTION_HISTORIES_REQUEST = `${PREFIX}REDEMPTION_HISTORIES_REQUEST`

/******************************************************************************************
* End Customer redemption histories
******************************************************************************************/

/******************************************************************************************
 * Customer redemption histories
 ******************************************************************************************/
export const CUSTOMER_LIST_SET_POINT_ACTIVITIES = `${PREFIX}SET_POINT_ACTIVITIES`

export const CUSTOMER_LIST_POINT_ACTIVITIES_REQUEST = `${PREFIX}POINT_ACTIVITIES_REQUEST`

/******************************************************************************************
 * End Customer redemption histories
 ******************************************************************************************/

/******************************************************************************************
 * Customer Details
 ******************************************************************************************/

export const CUSTOMER_LIST_CUSTOMER_DETAIL_REQUEST = `${PREFIX}CUSTOMER_DETAIL_REQUEST`

export const CUSTOMER_LIST_SET_CUSTOMER_DETAIL = `${PREFIX}SET_CUSTOMER_DETAIL`

export const CUSTOMER_LIST_CLOSE_CUSTOMER_DETAIL = `${PREFIX}CLOSE_CUSTOMER_DETAIL`

export const CUSTOMER_LIST_RECEIPT_REQUEST = `${PREFIX}RECEIPT_REQUEST`

export const CUSTOMER_LIST_SET_RECEIPT = `${PREFIX}SET_RECEIPT`

/******************************************************************************************
 * End Customer Details
 ******************************************************************************************/

/******************************************************************************************
 * Export/Import
 ******************************************************************************************/
export const CUSTOMERS_DOWNLOAD_TEMPLATE = `${PREFIX}DOWNLOAD_TEMPLATE`
export const CUSTOMER_LIST_EXPORT = `${PREFIX}EXPORT`
/******************************************************************************************
 * End Export/Import
 ******************************************************************************************/

export const CUSTOMER_LIST_SHOW_IMPORTING_MODE_MODAL = `${PREFIX}SHOW_IMPORTING_MODE_MODAL`
export const CUSTOMER_LIST_HIDE_IMPORTING_MODE_MODAL = `${PREFIX}HIDE_IMPORTING_MODE_MODAL`
export const CUSTOMER_LIST_CHANGE_MODAL_VISIBILITY = `${PREFIX}CHANGE_MODAL_VISIBILITY`



// WEBPACK FOOTER //
// ./app/actions/customers/list/constants.js